if (!customElements.get('product-image-cta')) {
  customElements.define('product-image-cta', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('button')?.addEventListener('click', () => {
        const root = this.closest('.shopify-section');
        const selector = root?.querySelector('.main-product__selector--compact-outfit');
        if (!selector) return;
        const message = selector.querySelector('[data-size-choice-message]');
        if (message) message.hidden = false;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        selector.scrollIntoView({behavior: reduced ? 'auto' : 'smooth', block: 'start'});
        const control = selector.querySelector('select, input[type="radio"]:not(:disabled)');
        control?.focus({preventScroll: true});
      });
    }
  });
}
